module.exports = __webpack_public_path__ + "media/images/achievement_category/learning_report_time_count-13948149da29a32b0823e94606e20ef8.png";